<script lang="ts" setup>
import {
  CollapsibleContent,
  CollapsibleRoot,
  CollapsibleTrigger,
} from '@fondof-ui/components/collapsible'
import ProductViewPropertiesHeadline from '@storefront-satch/components/organisms/product-view-properties/ProductViewPropertiesHeadline.vue'
</script>
<template>
  <CollapsibleRoot
    :class="[
      'group/item',
      'flex w-full flex-wrap',
      'mb-2.5 content-start',
      'sm:w-[50%] md:w-[33%]',
    ]"
  >
    <CollapsibleTrigger>
      <ProductViewPropertiesHeadline>
        <slot name="headline" />
      </ProductViewPropertiesHeadline>
    </CollapsibleTrigger>
    <CollapsibleContent
      class="mb-[2.5em] mt-0 w-full overflow-hidden pr-0 pt-[1em] text-xs transition-all duration-[0.3s] ease-linear"
    >
      <div
        :class="[
          'prose prose-p:text-xs prose-p:mt-0',
          'prose-ul:pl-0 prose-ul:m-0 prose-li:mt-0 prose-li:mb-2.5 prose-li:list-none prose-li:pl-0 prose-li:text-xs',
          'prose-a:text-primary prose-a:no-underline prose-strong:font-bold',
          'prose-img:inline prose-img:max-w-[250px] prose-img:max-h-[120px] prose-img:w-[40%] prose-img:mt-5 prose-img:mr-[5%]',
        ]"
      >
        <slot name="content" />
      </div>
    </CollapsibleContent>
  </CollapsibleRoot>
</template>
